import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { useQuery, useQueryClient } from '@tanstack/react-query'; // useMutation entfernt
// theme importieren
import { theme } from '../styles/theme';
import { useAnalysisStore } from '../store/analysisStore';
import PageLayout from '../components/layout/PageLayout';
import ChatHistory from '../components/chat/ChatHistory';
// MessageInput und Button werden nicht mehr benötigt
// import MessageInput from '../components/chat/MessageInput';
import AnalysisWizard from '../components/analysis/AnalysisWizard';
// import Button from '../components/common/Button';
import { getChatMessages } from '../api/chats'; // addChatMessage entfernt
import { useChatStore } from '../store/chatStore';
// Icon für Warnhinweis importieren
import { FiAlertTriangle } from 'react-icons/fi';

const ChatPage = () => {
  const { chatId } = useParams();
  const {
    setCurrentChatId,
    setChatMessages,
    // addChatMessage: storeChatMessage, // Nicht mehr benötigt
  } = useChatStore();
  const { isWizardOpen, setWizardOpen } = useAnalysisStore();
  const queryClient = useQueryClient();

  // Set current chat ID in store
  useEffect(() => {
    setCurrentChatId(chatId || null);
  }, [chatId, setCurrentChatId]);

  // Fetch chat messages
  const { data: messages, isLoading } = useQuery({
    queryKey: ['chat', chatId, 'messages'],
    queryFn: () => getChatMessages(chatId),
    enabled: !!chatId,
    onSuccess: (data) => {
      if (chatId) {
        setChatMessages(chatId, data);
      }
    },
  });

  // Add message mutation (nicht mehr benötigt)
  // const addMessageMutation = useMutation({...});

  // Handle send message (nicht mehr benötigt)
  // const handleSendMessage = (content) => {...};

  // Handle analysis complete
  const handleAnalysisComplete = () => {
    setWizardOpen(false);
    if (chatId) {
      queryClient.invalidateQueries({
        queryKey: ['chat', chatId, 'messages'],
      });
    }
  };

  // If no chat is selected, show welcome screen (bleibt unverändert)
  if (!chatId) {
    return (
      <PageLayout>
        <WelcomeContainer>
          <WelcomeTitle>Willkommen bei Law-AI</WelcomeTitle>
          <WelcomeText>
            Starten Sie eine neue Analyse oder wählen Sie einen bestehenden Chat
            aus der Seitenleiste, um fortzufahren.
          </WelcomeText>
          <DisclaimerBox>
            <DisclaimerIcon>
              <FiAlertTriangle size={20} />
            </DisclaimerIcon>
            <DisclaimerText>
              <strong>Wichtiger Hinweis:</strong> KI-Ergebnisse können Fehler
              enthalten ('Halluzinationen'). Überprüfen Sie alle Informationen
              sorgfältig. Dies ist keine Rechtsberatung, keine Haftung für
              Richtigkeit.
            </DisclaimerText>
          </DisclaimerBox>
        </WelcomeContainer>
      </PageLayout>
    );
  }

  // Rendern der Chat-Ansicht, wenn eine chatId vorhanden ist
  return (
    <PageLayout>
      <Container>
        {isLoading ? (
          <LoadingText>Lade Nachrichten...</LoadingText>
        ) : (
          // Der <></> Fragment ist nicht mehr nötig, da nur ein Kind-Element übrig bleibt
          <ChatContainer>
            <ChatHistory messages={Array.isArray(messages) ? messages : []} />
          </ChatContainer>
          // --- ControlsContainer komplett entfernt ---
        )}
      </Container>

      {/* Analysis Wizard Modal (bleibt unverändert) */}
      <AnalysisWizard
        isOpen={isWizardOpen}
        onClose={() => setWizardOpen(false)}
        chatId={chatId}
        onComplete={handleAnalysisComplete}
      />
    </PageLayout>
  );
};

// --- Styled Components ---

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: calc(100vh - 70px); /* Beispiel: Annahme 70px für Header/Padding */
  overflow: hidden;
`;

const ChatContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 1rem;
`;

// ControlsContainer wird nicht mehr verwendet
// const ControlsContainer = styled.div`...`;

const LoadingText = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${theme.colors.textLight};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

// WelcomeContainer und zugehörige Styles bleiben unverändert
const WelcomeContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  text-align: center;
  padding: 2rem;
`;

const WelcomeTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 1rem;
  color: ${theme.colors.heading};
`;

const WelcomeText = styled.p`
  font-size: 1.125rem;
  color: ${theme.colors.textLight};
  max-width: 600px;
  margin-bottom: 2rem;
`;

const DisclaimerBox = styled.div`
  background-color: ${theme.colors.warningBackground || '#fffbe6'};
  color: ${theme.colors.warningText || '#8a6d3b'};
  border: 1px solid ${theme.colors.warningBorder || '#ffeeba'};
  border-radius: ${theme.borderRadius.md};
  padding: ${theme.spacing.md};
  margin-top: ${theme.spacing.lg};
  display: flex;
  align-items: flex-start;
  gap: ${theme.spacing.md};
  max-width: 650px;
  text-align: left;
`;

const DisclaimerIcon = styled.div`
  flex-shrink: 0;
  margin-top: 3px;
  color: ${theme.colors.warning || '#ffc107'};
`;

const DisclaimerText = styled.p`
  font-size: 0.9rem;
  line-height: 1.5;
  margin: 0;

  strong {
    color: inherit;
    font-weight: 600;
  }
`;

export default ChatPage;
